// extracted by mini-css-extract-plugin
export default {"toggleBtn__btn":"ToggleButtons_toggleBtn__btn__-Oz8u","toggleBtn__icon":"ToggleButtons_toggleBtn__icon__BJOUe"};